import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

// Hook pour sauvegarder et restaurer la position de scroll vers les sections
const useScrollPosition = () => {
  const location = useLocation();
  const isFirstRender = useRef(true);

  // Fonction pour obtenir l'ancre de section depuis une route de détail
  const getSectionAnchor = (pathname) => {
    if (pathname.includes('/veilleusedelieux/résidences/')) {
      return 'résidences';
    }
    if (pathname.includes('/veilleusedelieux/parutions/')) {
      return 'parutions';
    }
    if (pathname.includes('/Ceramiste/bols/')) {
      return 'bols';
    }
    if (pathname.includes('/Ceramiste/chawans/')) {
      return 'chawans';
    }
    // Ajouter d'autres mappings si nécessaire
    return null;
  };

  // Fonction pour obtenir la route "parent" d'une route de détail
  const getParentRoute = (pathname) => {
    if (pathname.includes('/veilleusedelieux/résidences/') || pathname.includes('/veilleusedelieux/parutions/')) {
      return '/veilleusedelieux';
    }
    if (pathname.includes('/Ceramiste/bols/') || pathname.includes('/Ceramiste/chawans/')) {
      return '/Ceramiste';
    }
    return pathname;
  };

  // Scroll vers une section spécifique
  const scrollToSection = (sectionId) => {
    if (!sectionId) return;
    
    // Attendre que le DOM soit prêt
    const attemptScroll = () => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
        return true;
      }
      return false;
    };

    // Essayer plusieurs fois si l'élément n'est pas encore rendu
    if (!attemptScroll()) {
      setTimeout(() => {
        if (!attemptScroll()) {
          setTimeout(attemptScroll, 200);
        }
      }, 100);
    }
  };

  useEffect(() => {
    // Vérifier si c'est un retour depuis une page de détail
    const handleNavigation = () => {
      // Récupérer l'information de section depuis l'état de l'historique
      if (window.history.state && window.history.state.fromSection) {
        const targetSection = window.history.state.fromSection;
        setTimeout(() => {
          scrollToSection(targetSection);
        }, 100);
      }
    };

    // Appeler lors du premier rendu si on arrive sur la page
    if (!isFirstRender.current) {
      handleNavigation();
    } else {
      isFirstRender.current = false;
    }

  }, [location.pathname]);

  // Écouter les événements de navigation du navigateur
  useEffect(() => {
    const handlePopState = (event) => {
      // Si c'est un retour en arrière et qu'on a des données de section
      if (event.state && event.state.targetSection) {
        setTimeout(() => {
          scrollToSection(event.state.targetSection);
        }, 100);
      }
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  // Sauvegarder la section actuelle dans l'état de l'historique quand on navigue
  useEffect(() => {
    const currentSection = getSectionAnchor(location.pathname);
    if (currentSection && window.history.replaceState) {
      window.history.replaceState(
        { ...window.history.state, targetSection: currentSection },
        ''
      );
    }
  }, [location.pathname]);

  return { scrollToSection, getSectionAnchor };
};

export default useScrollPosition;